/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import StyledTableCell from '../../../../../../components/ui-elements/table/StyledTableCell';
import StyledTableRow from '../../../../../../components/ui-elements/table/StyledTableRow';
import { IconButton } from '@mui/material';
import { BsInfoCircleFill } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import AdminUserInfo from './AdminUserInfo';
import { useState } from 'react';
import DialogContainer from '../../../../../../components/shared/Dialog/DialogContainer'
import Loader from '../../../../../../components/ui-elements/loader';
import { getAllUsers } from '../../../../../../store/reducers/user/userAction';
import { useCallback } from 'react';

const UsersList = () => {
    const [openUserInfo, setOpenUserInfo] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState("");
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const usersInfo = useSelector(state => state.user.usersInfo)
    const fetchUsers = useCallback(async () => {
        setLoading(true);
        try {
            await dispatch(getAllUsers({
                "offset": 0,
                "limit": 100,
                "skip": 0,
                "order": "desc",

                "fields": {
                    "adminid": true,
                    "username": true,
                    "lastname": true,
                    "firstname": true,
                    "email": true,
                    "cellphone": true,
                    "cellphonevalidated": true,
                    "useravatar": true
                }
            })).unwrap();
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }, [dispatch]);

    useEffect(() => {
        fetchUsers()
    }, [fetchUsers]);
    const handleCloseDialog = () => {
        setOpenUserInfo(false);
    };
    return (
        <>
            {!loading ? <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                        <StyledTableRow>
                            <StyledTableCell label="Admin ID" />
                            <StyledTableCell label="Name" />
                            <StyledTableCell label="E-mail" />
                            <StyledTableCell label=" " />

                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                        {usersInfo?.length > 0 && usersInfo?.map((row) => (
                            <StyledTableRow key={row.adminid}>
                                <StyledTableCell label={row.adminid} />
                                <StyledTableCell label={`${row.firstname ?? "N/A"} ${row.lastname ?? "N/A"}`} />
                                <StyledTableCell label={row.email} />
                                <StyledTableCell align="right"  >
                                    <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { setSelectedUserId(row.userid); setOpenUserInfo(true) }}>
                                        <BsInfoCircleFill />
                                    </IconButton>
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer> : (<Loader />)}
            <DialogContainer
                open={openUserInfo}
                handleClose={handleCloseDialog}
            >
                <AdminUserInfo
                    userid={selectedUserId}
                    handleClose={handleCloseDialog} />
            </DialogContainer>
        </>
    )

}

export default UsersList;
